import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { graphql, compose } from 'react-apollo';

// Redux Form
import { Field, reduxForm, change, formValueSelector } from 'redux-form';
// Redux
import { connect } from 'react-redux';

import {
  Button,
  Form,
  Grid,
  Row,
  FormGroup,
  Col,
  ControlLabel,
  FormControl,
  FieldGroup,
  Panel,
  Label,
} from 'react-bootstrap';
import cx from 'classnames';
import FontAwesome from 'react-icons/fa';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../Payout.css';

// Graphql
import getPaymentMethodsQuery from './getPaymentMethods.graphql';

// Locale
import messages from '../../../locale/messages';

class PayoutMethods extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    previousPage: PropTypes.func.isRequired,
    formatMessage: PropTypes.func,
  };

  static defaultProps = {
    PaymentMethodsData: {
      loading: true,
      getPaymentMethods: [],
    },
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const {
      PaymentMethodsData: { loading },
    } = nextProps;
    const { change, paymentMethodId } = this.props;
    // if (getPaymentMethods != null && getPaymentMethods.length > 0) {
    //   if (paymentMethodId === undefined || paymentMethodId === null) {
    //     change('methodId', getPaymentMethods[0].id);
    //     change('paymentType', getPaymentMethods[0].paymentType);
    //     change('currency', getPaymentMethods[0].currency);
    //   }
    // }
  }

  handleChange(methodId, paymentType, currency) {
    const { change } = this.props;
    change('methodId', methodId);
    change('paymentType', paymentType);
    change('currency', currency);
  }

  render() {
    const { error, handleSubmit, previousPage } = this.props;
    const { paymentMethodId } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <form onSubmit={handleSubmit}>
        <Panel>
          <Panel.Heading>
            <FormattedMessage {...messages.addPayout} />
          </Panel.Heading>
          <Panel.Body>
            <div className={s.panelBody}>
              <p className={s.payoutIntro}>
                <FormattedMessage {...messages.payoutIntro1} />
              </p>
            </div>
          </Panel.Body>
          <Panel.Footer>
            <div>
              <Button
                className={cx(
                  s.button,
                  s.btnlarge,
                  s.btnPrimaryBorder,
                  s.btnRight,
                )}
                onClick={previousPage}
              >
                <FormattedMessage {...messages.back} />
              </Button>
              <Button
                className={cx(s.button, s.btnPrimary, s.btnlarge)}
                type="submit"
              >
                <FormattedMessage {...messages.next} />
              </Button>
            </div>
          </Panel.Footer>
        </Panel>
      </form>
    );
  }
}

PayoutMethods = reduxForm({
  form: 'PayoutForm', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(PayoutMethods);

const selector = formValueSelector('PayoutForm');

const mapState = state => ({
  paymentMethodId: 2,
});

const mapDispatch = {
  change,
};

export default compose(
  injectIntl,
  withStyles(s),
  connect(
    mapState,
    mapDispatch,
  ),
)(PayoutMethods);



// WEBPACK FOOTER //
// ./src/components/Payout/PayoutForm/PayoutMethods.js